export default [
  {
    path: "/voice-alert-settings",
    name: "voice-alert-settings",
    component: () => import("@/views/voiceAlertSettings/View.vue"),
    meta: {
      pageTitle: "breadcrumb.voiceAlertSettings",
      navActiveLink: "voice-alert-settings",
      resource: "voice-settings",
      action: "read",
      breadcrumb: [
        {
          text: "breadcrumb.voiceAlertSettings",
          active: true,
        },
      ],
    },
  },
];
``;
